export default __webpack_public_path__ + "static/media/undraw_completed_tasks_vs6q.5dfbf4c8.svg";